var mediaGroup = {
    inline: false,
    group: 'block',
    content: 'media+',
    attrs: {},
    parseDOM: [
        {
            tag: 'div[data-node-type="mediaGroup"]',
        },
        {
            tag: 'div[class="MediaGroup"]',
        },
    ],
    toDOM: function () {
        return [
            'div',
            {
                'data-node-type': 'mediaGroup',
            },
            0,
        ];
    },
};

export { mediaGroup };



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/node_modules/@atlaskit/adf-schema/dist/esm/schema/nodes/media-group.js